<template>
  <div class="block-information clearfix" v-loading="loading">
    <div class="fr">
      <img src="@/../public/static/img/blockView/java.png">
    </div>
    <div class="fl">
      <span class="angle"></span>
      <div class="tit">
        {{$t("HyperBlockList")}}
      </div>
      <section id="tab" class="section2">
        <div style="width: 100%;">
          <table class="table">
            <tr>
              <th v-text="$t('HBlock')"></th>
              <!-- HBlock -->
              <th v-text="$t('LChains')"></th>
              <!-- LChains -->
              <th v-text="$t('Blocks')"></th>
              <th v-text="$t('Apps')"></th>
              <th v-text="$t('Time')"></th>
            </tr>
            <tr
            v-for="(item,index) in hyperblocks"
            :key="index"
            @click="$router.push(`/HyperblockView/${item.Hyperblock}`)">
              <td>
                <a href="javascript:;" v-text="item.Hyperblock">
                </a>
              </td>
              <td>{{item.chains}}</td>
              <td>{{item.Blocks}}</td>
              <td>{{item.apps}}</td>
              <td>{{$retTime(item.time*1000)}}</td>
            </tr>
          </table>
        </div>
        <!-- <router-link
        v-for="(item,index) in hyperblocks"
        class="new_chains clearfix"
        :to="`/HyperblockView/${item.Hyperblock}`"
        :key="index">
          <div class="fl">
            <div class="fl block">
              <div class="new_img">

              </div>
            </div>
            <div class="fl new_Hyperblock">
              <span class="cont" v-text="item.Hyperblock"></span>
              <span class="key" v-text="$t('HyperBlock')">超块号</span>
            </div>
          </div>
          <div class="fr bg2 hyperBlockView">
            <div class="fl blocks" style="width: 25%;">
              <span class="cont">{{item.chains}}</span>
              <span class="key" v-text="$t('Chains')">区块链数</span>
            </div>
            <div class="fl difficulty" style="width: 25%;">
              <span class="cont">{{item.Blocks}}</span>
              <span class="key" v-text="$t('Blocks')">区块数</span>
            </div>
            <div class="fl concensus" style="width: 50%;">
              <span class="cont">{{$retTime(item.time*1000)}}</span>
              <span class="key" v-text="$t('Time')">时间戳</span>
            </div>
          </div>
        </router-link> -->
        <!-- <router-link v-for="(item,index) in hyperblocks" :to="`/HyperblockView/${item.Hyperblock}`" class="box"  :key="index">
          <div class="clearfix">
            <div class="fl img"></div>
            <div class="fl">
              <div class="blocks" v-text="item.Hyperblock"></div>
              <div class="Chains clearfix">
                <span class="key" v-text="$t('Chains')">区块链数</span>
                <span class="cont fl" v-text="item.chains"></span></div>
              <div class="Blocks clearfix">
                <span class="key" v-text="$t('Blocks')">区块数</span>
                <span class="cont fl" v-text="item.Blocks"></span>
              </div>
            </div>
          </div>
          <div class="time clearfix">
            <span class="key" v-text="$t('Time')">时间戳</span>
            <span class="cont fl">{{$retTime(item.time*1000)}}</span>
          </div>
        </router-link> -->
      </section>
      <pages
        toLink="BrowserHome"
        :pageCount="pageCount"
        :page="page">
      </pages>
    </div>
  </div>
</template>
<script>
import pages from '@/components/pages.vue'
export default {
  components:{
    pages
  },
  data(){
    return{
      pageCount:'',
      hyperblocks:[],
      page:1,
      loading: true,
    }
  },
  watch:{
    $route(){
      this.init();
    }
  },
  created(){
    this.init();
  },
  methods:{
    init(){
      this.$http({
        url:`hyperchain/home?page=${this.$route.params.page}&pageSize=10`,
        baseURL: process.env.VUE_APP_CURRENTMODE,
        method: 'get',
      }).then((res)=>{
        var data = res.data;
        if(data.ret == 200){
          this.hyperblocks = data.data.data;
          this.pageCount = data.data.pages.pageCount;
          if(data.data.pages.page<1){
            this.page = 1;
          }else{
            this.page = data.data.pages.page;
          }
        }
        this.loading = false;
      })
    }
  }
}
</script>
<style lang="scss" scoped>
  @media screen and (max-width: 768px) {
    .section2 .table{
      width: 500px!important;
    }
  }
</style>
